module.exports = __webpack_public_path__ + "img/bg-pic.bbd3e17e.png";